import React, { FC, useEffect, useState } from 'react';
import { Box, Button, Flex, Switch } from '@chakra-ui/react';

import { Dialog } from '@app/components/common/modals';
import { SwitchField, TextField } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';
import { useApi } from '@app/hooks';

interface CreateRouteProps {
  open: boolean;
  setOpen(value: boolean): void;
  route?: EntityBase;
}

const EditRoute: FC<CreateRouteProps> = ({ open, setOpen, route }) => {
  const [value, setValue] = useState<string>(route?.name || '');
  const [is_active, setIsActive] = useState<boolean>(route?.is_active || false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useQueryTable();
  const api = useApi();

  const onSubmit = async () => {
    setLoading(true);
    if (route) {
      await api.acb.updateRoute({ id: route.id, name: value, is_active });
    } else {
      await api.acb.createRoute(value);
    }
    setLoading(false);
    setOpen(false);
    refetch();
  };

  useEffect(() => {
    setValue(route?.name || '');
    setIsActive(route?.is_active);
  }, [route]);

  return (
    <Dialog
      title="Маршрут"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      actions={
        <>
          <Button onClick={onSubmit}>
            {!route ? 'Добавить' : 'Изменить'}
          </Button>
        </>
      }
    >
      <Flex mb={1} flexDirection='column' gap={4}>
        <TextField
          multiline
          rows={10}
          id=""
          label="Значение"
          value={value}
          onChange={setValue}
        />
        <SwitchField 
          label='Активен'
          value={is_active}
          onChange={setIsActive}
          id='is_active'
        />
      </Flex>
    </Dialog>
  );
};

export default EditRoute;
